import React, { Component } from 'react';
import { Button, Header, Segment, Dropdown, Form, Input, Container } from 'semantic-ui-react';
// eslint-disable-next-line
import FormSerializer from 'form-serializer';
import $ from 'jquery';
import { Helmet } from 'react-helmet';
import usstates from '../../util/states.json';
var validate = require("validate.js");

class Signup extends Component {
  constructor(){
      super();
      this.state = {data: null, signupMessage: ""};
      this.submit = this.submit.bind(this);
      this.clearForm = this.clearForm.bind(this);
  }

  submit(e){
      e.preventDefault();
      var fname = document.forms['signup']['firstname'].value
      var lname = document.forms['signup']['lastname'].value
      var email = document.forms['signup']['email'].value
      var title = document.forms['signup']['title'].value
      var phone = document.forms['signup']['phone'].value
      var company = document.forms['signup']['company'].value
      var state = document.forms['signup']['state'].value
      var website = document.forms['signup']['website'].value

      var inputObject = {
        firstname: fname,
        lastname: lname,
        title: title,
        email: email,
        phone: phone,
        company: company,
        state: state,
        website: website
      }

      var inputObjectCheck = {
        firstname:  {presence: {allowEmpty: false}},
        lastname: {presence: {allowEmpty: false}},
        title: {presence: {allowEmpty: false}},
        email: {
          presence: {allowEmpty: false},
          email: true
        },
        phone: {presence: {allowEmpty: false}},
        company: {presence: {allowEmpty: false}},
        state: {presence: {allowEmpty: false}},
        website: {presence: {allowEmpty: false}}
      }

      if(validate(inputObject, inputObjectCheck) === undefined){
      return $.ajax({
          url: 'https://9d8dvqtfo2.execute-api.us-west-2.amazonaws.com/prod/signup',
          type: 'POST',
          dataType: 'json',
          crossDomain: 'true',
          cache: false,
          data: $('form#signup').serializeJSON(),
          xhrFields: {
              withCredentials: false
          },
          beforeSend: function(xhr){
              xhr.setRequestHeader('Accept', 'application/json');
              xhr.setRequestHeader('Content-Type', 'application/json');
          },
          success: function(data) {
              this.setState({data: data, signupMessage: "Thank you for requesting access, we will be reaching out to you soon! Yay!"});
              this.clearForm();
          }.bind(this),
          error: function(xhr, status, err) {
              this.setState({signupMessage: "Error, could not signup."});
          }.bind(this)
      });
    } else {
      this.setState({signupMessage: "Please fill in all required fields and make sure all input fields have the correct format."});
    }
  }

  clearForm(){
      $('form#signup')[0].reset();
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>BeemaBroker: The Millennial Insurance Broker - Request access to our private beta.</title>
        </Helmet>
        <Segment id='request-acesss' style={{ padding: '8em 0em 4em 0em' }} vertical>
          <Container text>
            <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>Request access to our private beta. </Header>

            <Form size='large' onSubmit={this.submit} id='signup' style={{padding:'4em 0em'}}>
              <Form.Group widths='equal'>
                <Form.Field required>
                  <label>First name</label>
                  <Input name='firstname' required fluid placeholder='First name' maxLength='30' pattern='[A-Za-z ]+' title='only alphabetic characters allowed'/>
                </Form.Field>
                <Form.Field required>
                  <label>Last name</label>
                  <Input name='lastname' required fluid placeholder='Last name' maxLength='30' pattern='[A-Za-z ]+' title='only alphabetic characters allowed'/>
                </Form.Field>
                <Form.Field required>
                  <label>Title</label>
                  <Input name='title' required fluid placeholder='Role at Company' maxLength='20' pattern='[A-Za-z- ]+' title='only alphabetic characters allowed'/>
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required>
                  <label>Email</label>
                  <Input name='email' required fluid placeholder='Email Address' maxLength='70' type='email'/>
                </Form.Field>
                <Form.Field required>
                  <label>Phone Number</label>
                  <Input name='phone' type='tel' required fluid placeholder='Phone Number' minLength='10' maxLength='10' pattern='[0-9]+' title='10 digits only'/>
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required>
                  <label>Company Name</label>
                  <Input name='company' required fluid placeholder='Company Name' pattern="[A-Za-z0-9-,\.'_! ]+" title='only alphanumeric characters allowed' maxLength='40'/>
                </Form.Field>
                <Form.Field required>
                <label>Company HQ State</label>
                  <Dropdown required name='state' placeholder='State' search selection options={usstates} onChange={(e, data) => {$('#state').val(data.value);}}/>
                  <Input required name='state' id='state' type='hidden' />
                </Form.Field>
              </Form.Group>
              <Form.Field required>
                <label>Company Website</label>
                <Input name='website' required fluid placeholder='Company Website (example.com)' maxLength='80'
                  pattern='^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$' />
              </Form.Field>
              <Button type='submit' floated='right' color='teal'>
                Request Access
              </Button>
              <h1 style={{color: 'teal'}}>{this.state.signupMessage}</h1>
            </Form>
          </Container>
        </Segment>
      </div>
    );
  }
};

export default Signup;



// WEBPACK FOOTER //
// ./src/js/Home/Signup.js